import { createFileRoute } from "@tanstack/react-router";
import { WhatsappComposer } from "@/components/admin/disparos/WhatsappComposer";
import { z } from "zod";

export const Route = createFileRoute("/admin/marketing/whatsapp")({
  validateSearch: z.object({ criar: z.literal("campanha").optional() }),
  component: WhatsappComposer,
});
